/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {ComplexRatioPredicate} from 'components/PropertyWidget/model';

import {aggregateBag} from 'features/mediaplan-progress/helpers/aggregateBag';
import {ComponentBag} from 'features/mediaplan-progress/types';

import {ComplexValue, GraphComplexValues, GraphComplexValuesList} from '../../models/common';

interface Options {
  data: CommonChartData[];
  graphComplexValuesList: GraphComplexValuesList;
  complexRatioPredicate: ComplexRatioPredicate<ComplexValue>;
}

export const ratioFactFromChartData = ({
  data,
  graphComplexValuesList,
  complexRatioPredicate,
}: Options): number => {
  const bagByDay: Record<string, ComponentBag> = {};
  const factDays: string[] = [];

  data.forEach(point => {
    const entry: GraphComplexValues | undefined = (
      graphComplexValuesList as Record<string, GraphComplexValues | undefined>
    )[point.name];
    if (entry) {
      bagByDay[point.name] = entry.values;
    }
    if (point.primary !== undefined) {
      // Паритет с легаси statsComplexRatio: bag обязателен для точки факта. Его отсутствие —
      // это битые/частичные данные; бросаем, чтобы проблема всплыла сразу, а не давала тихо
      // неверный ratio.
      if (!entry) {
        throw new Error(
          `ratioFactFromChartData: нет graphComplexValuesList для точки факта «${point.name}»`,
        );
      }
      factDays.push(point.name);
    }
  });

  const aggregated = aggregateBag(bagByDay, factDays) as ComplexValue;
  return complexRatioPredicate(aggregated);
};
